declare global {
  interface Window {
    Cal?: any;
  }
}

const CAL_EMBED_SRC = 'https://app.cal.com/embed/embed.js';
export const CAL_NAMESPACE = '15min';
export const CAL_LINK = 'aditya-naik/15min';
export const CAL_CONFIG = { layout: 'month_view', useSlotsViewOnSmallScreen: 'true' };

// Verbatim port of Cal.com's own element-click embed snippet (the one
// their dashboard hands out): defines a queueing window.Cal stub that
// loads the real embed.js once and namespaces calls under it. The real
// script replaces the stub with its actual implementation once loaded
// (draining whatever queued in the meantime) and, per Cal's docs, wires
// its own delegated click listener for any element carrying
// data-cal-link — nothing further needed on our end to open the popup.
export function initCalEmbed() {
  const C = window as unknown as { Cal?: any; document: Document };
  if (C.Cal) return;
  const push = (a: any, ar: IArguments | any[]) => a.q.push(ar);
  const d = C.document;
  C.Cal = function (this: any, ...ar: any[]) {
    const cal = C.Cal;
    if (!cal.loaded) {
      cal.ns = {};
      cal.q = cal.q || [];
      d.head.appendChild(d.createElement('script')).setAttribute('src', CAL_EMBED_SRC);
      cal.loaded = true;
    }
    if (ar[0] === 'init') {
      const api: any = function (this: any, ...apiAr: any[]) { push(api, apiAr); };
      const namespace = ar[1];
      api.q = api.q || [];
      if (typeof namespace === 'string') {
        cal.ns[namespace] = cal.ns[namespace] || api;
        push(cal.ns[namespace], ar);
        push(cal, ['initNamespace', namespace]);
      } else {
        push(cal, ar);
      }
      return;
    }
    push(cal, ar);
  };

  const Cal = C.Cal;
  Cal('init', CAL_NAMESPACE, { origin: 'https://app.cal.com' });
  Cal.config = Cal.config || {};
  Cal.config.forwardQueryParams = true;
  Cal.ns[CAL_NAMESPACE]('ui', { hideEventTypeDetails: false, layout: 'month_view' });
}
